<template>
  <ContentBlocks :entry="entry" />
</template>

<script>
import topicPage, { TopicQuery } from '@/mixins/topicPage';
import { stripTrailingSlash } from '@/utils/common';
import ContentBlocks from '@/components/common/ContentBlocks';

export default defineNuxtComponent({
  name: 'TopicRootIndex',

  components: { ContentBlocks },

  mixins: [topicPage],

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const slug = stripTrailingSlash(route.path).split('/').slice(-1)[0];
    const { locale } = useNuxtApp().$i18n;
    const uri = slug;
    const variables = { site: locale.value, uri, slug };

    const { entry, seomatic, categories } = await $craftRequest(TopicQuery, variables);

    return { entry, seomatic, categories };
  },
  mounted() {
    this.$emit('onAllCategories');
    this.gtmPushPageMeta();
  },
  methods: {},
});
</script>
